import { useCallback, useState } from 'react';

export type ToggleHook = [boolean, (value?: unknown | boolean) => void];
export const useToggle = (initialValue = false): ToggleHook => {
  const [state, setState] = useState(initialValue);
  const toggle = useCallback(
    (value: unknown | boolean) => setState(curr => (typeof value === 'boolean' ? value : !curr)),
    [setState]
  );
  return [state, toggle];
};
